var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remoteDataPending)?_c('zf-progress',{attrs:{"alignment":_vm.alignment,"color":_vm.color,"remoteData":_vm.remoteData}}):(_vm.remoteDataFailed)?_c('zf-alert',{attrs:{"alignment":_vm.alignment,"remoteData":_vm.remoteData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }